export default "__VITE_ASSET__CFMrY1v9__"